export class PaymentAmountForDoctorModel {
  DoctorARLocId : string;
  DoctorName : string;
  amount: number;
  isSelected: boolean = false;
  PaymentProcessorId: string;
  ARAccountID: string;

}
